var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "dropdown-item d-flex align-items-center",
      attrs: { type: "button" },
      on: { click: _setup.onClick },
    },
    [
      _c("span", {
        staticClass: "me-2",
        class: {
          "bi-square": !_setup.lineWrapping,
          "bi-check-square": _setup.lineWrapping,
        },
      }),
      _vm._v("\n    Line wrapping\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }